




















































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  putData, postData, getInfo, emptyCruisePlan, CruisePlanData, CruisePlanTeamMemberData, CruisePlanScheduleData,
  CruisePlanUnitData
} from '@/api/cruisePlan/index'
import {
  DDLItem, DefDDLItem, getLookupByType
} from '@/api/common/select'
import { enLookupType, enFirstType } from '@/configs/enums'
import { prefixZero, getDDLItem } from '@/configs/functions'
import {
  validateIntKey
} from '@/configs/validate'
import CruisePlanSelectUnit from '@/components/heritageCruise/cruisePlan/selectUnit.vue'
import CruisePlanSelectUnits from '@/components/heritageCruise/cruisePlan/selectUnits.vue'
import CruisePlanSearchUnits from '@/components/heritageCruise/cruisePlan/searchUnits.vue'
import CruisePlanSelectUsers from '@/components/heritageCruise/cruisePlan/selectUsers.vue'
import PageForm from '@/components/pageLayout/form.vue'

import { UserData } from '@/api/systemManage/user'
import { namespace } from 'vuex-class'
const UserModule = namespace('user')

const getFormRules = (id: number, form: { [key: string]: string | any }) => {
  return {
    PlanName: [
      { required: true, message: '巡查计划名称不能为空', trigger: 'blur' }
    ],
    ScheduleId: [
      { required: true, validator: validateIntKey('请选择巡查周期'), trigger: 'change' }
    ],
    FromDate: [
      { required: true, message: '请选择计划生效时间', trigger: 'blur' }
    ],
    StartHour: [
      { required: true, message: '请选择计划开始时间', trigger: 'blur' }
    ],
    WorkHours: [
      {
        required: true,
        validator: validateIntKey('请输入计划时长'),
        // message: '请输入计划时长',
        trigger: 'blur'
      }
    ]
    //FromDate: [{ required: true, validator: validateDateRange(form, 'FromDate', 'ToDate', '开始时间不能大于结束时间'), trigger: "blur" }],
    //ToDate: [{ required: true, validator: validateDateRange(form, 'FromDate', 'ToDate', '开始时间不能大于结束时间'), trigger: "blur" }]
  }
}

@Component({
  components: { PageForm, CruisePlanSelectUnit, CruisePlanSelectUnits, CruisePlanSearchUnits, CruisePlanSelectUsers }
})
export default class CruisePlanFrom extends Vue {
  @UserModule.Getter('userInfo')
  public curUser!: UserData
  public expandNames = ['info', 'schedule', 'teamMembers', 'unit']
  public firstType: number = enFirstType.Select
  public defItem: DDLItem = DefDDLItem(this.firstType)
  public emptyForm: CruisePlanData = emptyCruisePlan

  public allText: string = '所有'

  public form = Object.assign({}, this.emptyForm)
  public loading = false

  public rules = getFormRules(0, this.form)
  public scheduleList: DDLItem[] = []

  // dynamic component
  public $refs!: {
    formCtrl: PageForm
    selectUnitCtrl: CruisePlanSelectUnit
    selectUnitsCtrl: CruisePlanSelectUnits
    searchUnitsCtrl: CruisePlanSearchUnits
    selectUsersCtrl: CruisePlanSelectUsers
  }
  public created() {
    const id = +this.$router.currentRoute.params.id || 0
    if (id == 0) {
      var msg = `<div>
计划配置后，会按照巡查周期下发任务，不用重复配置。
<p/>如巡查周期为天，则每天凌晨下发今天的巡查任务。
<p/>巡查周期周期为月，则每月1号凌晨会下发本月的巡查任务。
        </div>`
      this.$alert(msg, '计划说明', { dangerouslyUseHTMLString: true })

    }
    this.fetchSource()
    this.fetchData()
  }
  public mounted() {
    //修改文保单位 回传事件
    window.eventBus.$on(
      'submitCruisePlanSelectUnit', (data: CruisePlanUnitData) => {
        this.addUnit(data)
      })
    //添加文保单位 回传事件
    window.eventBus.$on(
      'submitCruisePlanSelectUnits', (data: CruisePlanUnitData[]) => {
        this.addUnits(data)
      })
    //审核结束后回调函数
    window.eventBus.$on('submitCruisePlanSearchUsers', (data: CruisePlanTeamMemberData[]) => {
      this.addTeamMember(data)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('submitCruisePlanSelectUnit')
    window.eventBus.$off('submitCruisePlanSelectUnits')
    window.eventBus.$off('submitCruisePlanSearchUsers')
  }
  public get pickerOpts(): any {
    let opt: any = { start: '00:00', step: '00:15', end: '24:00' }
    // let f = this.form
    // if (f.StartHour != '') {
    //   opt = {
    //     start: f.StartHour, step: '00:15', end: f.StartHour
    //   }
    // }
    return opt
  }
  public minDay: number = 1
  public maxDay: number = 7
  public frequenceUnit: string = '一天'
  public scheduleTooltip: string = '系统根据周期自动生成巡查时段，如有需要请自行调整'
  public scheduleChange(rebuild: boolean) {
    const f = this.form
    if (f.ScheduleId > 0) {
      const item = getDDLItem(this.scheduleList, f.ScheduleId)
      if (item) {
        this.scheduleTooltip = item.ExInfo.Explain
        const code = item.ExInfo.Code
        f.ScheduleType = 2
        switch (code) {
          case 'day':
            f.ScheduleType = 1
            this.maxDay = 24
            this.frequenceUnit = '一天'
            break;
          case 'week':
            this.maxDay = 7
            this.frequenceUnit = '一周'
            break;
          case 'month':
            this.maxDay = 30
            this.frequenceUnit = '一个月'
            break;
          case 'quarter':
            this.maxDay = 30 * 3
            this.frequenceUnit = '一季度'
            break;
          case 'half-year':
            this.maxDay = 183
            this.frequenceUnit = '半年'
            break;
          case 'year':
            this.maxDay = 365
            this.frequenceUnit = '一年'
            break;
        }
        if (rebuild) {
          this.doneSchedule = false
          this.createSchedule()
        }
      }
    }
  }
  get endHour(): string {
    var f = this.form
    if (f.ScheduleType == 1) {
      if (f.ScheduleList.length > 0) {
        return f.ScheduleList[f.ScheduleList.length - 1].ScheduleEnd
      }
    }
    return ''
  }
  public getMinSpan(inputHour: string) {
    const start = this.form.StartHour.split(':')
    const hour: number = parseInt(start[0])
    const min: number = parseInt(start[1])
    const end = inputHour.split(':')
    const endHour: number = parseInt(end[0])
    const endMin: number = parseInt(end[1])
    const startDate = new Date(2000, 1, 1, hour, min, 0)
    const endDate = new Date(
      2000,
      1,
      hour > endHour ? 2 : 1, //是否跨夜
      endHour,
      endMin,
      0
    )
    const ms = endDate.getTime() - startDate.getTime()
    let mins = 0
    if (ms < 0) {
      mins = 0
    } else {
      mins = Math.floor(ms / 1000 / 60)
    }
    return mins
  }
  public addHour(startHour: any, addhours: number) {
    const start = startHour.split(':')
    const hour: number = parseInt(start[0])
    const min: number = parseInt(start[1])
    let endHour: number = hour + addhours
    if (endHour > 24) {
      endHour = endHour - 24
    }
    return prefixZero(endHour, 2) + ':' + prefixZero(min, 2)
  }
  public doneSchedule: boolean = false
  public createSchedule() {
    let f = this.form
    if (f.Frequence > this.maxDay) {
      this.$message({
        type: 'warning',
        message: '巡查次数不能大于' + this.maxDay + '次，已为您替换为' + this.maxDay + '。'
      })
      f.Frequence = this.maxDay
    }
    if (!this.doneSchedule) {
      if (f.ScheduleId == 0) {
        this.$message({
          type: 'warning',
          message: '请选择巡查周期'
        })
        return
      }
      if (f.ScheduleType == 1) {
        if (f.StartHour == '') {
          this.$message({
            type: 'warning',
            message: '请输入巡查开始时间'
          })
          return
        }
        if (f.WorkHours == 0) {
          this.$message({
            type: 'warning',
            message: '请输入巡查时长'
          })
          return
        }
        f.ScheduleList = []
        var startHour = f.StartHour
        //'按天'，按开始时间的小时往后顺延
        for (var i = 0; i < f.Frequence; i++) {
          const item = this.newScheduleItem(startHour)
          f.ScheduleList.push(item)
          startHour = item.ScheduleEnd
        }
      }
      else {
        f.ScheduleList = []
        var start = this.minDay
        var end = this.maxDay
        //计算平均天数，如果不能平均，就加上余数。使其能够平均分
        if (end % f.Frequence > 0) {
          end = end - (end % f.Frequence)
        }
        var avg = end / f.Frequence
        for (var i = 0; i < f.Frequence; i++) {
          end = start + avg
          if (i == f.Frequence - 1 && end != this.maxDay) {
            end = this.maxDay
          }
          f.ScheduleList.push(
            {
              Id: 0,
              CruisePlanId: f.Id,
              ScheduleStart: start + '',
              ScheduleEnd: end + '',
              TimespanStart: 0,
              TimespanEnd: 0
            })
          start = end
        }
      }
    }
  }
  public addSchedule() {
    let f = this.form
    if (f.ScheduleType == 1) {
      var startHour = f.StartHour
      if (f.ScheduleList.length > 0) {
        startHour = f.ScheduleList[f.ScheduleList.length - 1].ScheduleEnd
      }
      const item = this.newScheduleItem(startHour)
      f.ScheduleList.push(item)
    }
    else {
      var start = this.minDay
      if (f.ScheduleList.length > 0) {
        start = +f.ScheduleList[f.ScheduleList.length - 1].ScheduleEnd
      }
      f.ScheduleList.push(
        {
          Id: 0,
          CruisePlanId: f.Id,
          ScheduleStart: start + '',
          ScheduleEnd: this.maxDay + '',
          TimespanStart: 0,
          TimespanEnd: 0
        })
    }
    f.Frequence = f.ScheduleList.length
  }
  public editSchedule(index: number) {
    var item = this.form.ScheduleList[index]
    item.TimespanStart = this.getMinSpan(item.ScheduleStart)
    item.TimespanEnd = this.getMinSpan(item.ScheduleEnd)
    //如果开始时间查比结束时间差大 说明start跨天，而end没有跨天，那么end需要手动加一天
    if (item.TimespanStart > item.TimespanEnd) {
      item.TimespanEnd += 24 * 60
    }
  }
  public delSchedule(index: number) {
    this.$confirm('确定要删除吗?', '请确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        let f = this.form
        f.ScheduleList.splice(index, 1)
        f.Frequence = f.ScheduleList.length
      })
      .catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消操作'
        // });
      })
  }
  public newScheduleItem(startHour: string) {
    var f = this.form
    var endHour = this.addHour(startHour, f.WorkHours)
    var diffStart = this.getMinSpan(startHour)
    var diffEnd = this.getMinSpan(endHour)
    //如果开始时间查比结束时间差大 说明start跨天，而end没有跨天，那么end需要手动加一天
    if (diffStart > diffEnd) {
      diffEnd += 24 * 60
    }
    var item: CruisePlanScheduleData = {
      Id: 0,
      CruisePlanId: f.Id,
      ScheduleStart: startHour,
      ScheduleEnd: endHour,
      TimespanStart: diffStart,
      TimespanEnd: diffEnd
    }
    return item
  }
  //#region 巡查人员
  public openTeamMember() {
    window.eventBus.$emit('openCruisePlanSearchUsers')
  }
  public addTeamMember(data: CruisePlanTeamMemberData[]) {
    var f = this.form
    var curList = f.TeamMembers
    data.forEach((e: CruisePlanTeamMemberData, i: number) => {
      var newItem = {
        Id: 0,
        CruisePlanId: f.Id,
        ReferType: e.ReferType,
        ReferId: e.ReferId,
        ReferName: e.ReferName,
        CruiserId: e.CruiserId,
        CruiserName: e.CruiserName
      }
      const referName = (e.ReferName == '' ? '本级单位' : e.ReferName)
      //如果选了具体人员，需要判断是否已经有组织了。在选了组织的情况下，在选人员，需要提示人员已在组织中，不能重复添加
      var skip = false
      if (e.CruiserId > 0) {
        //判断是否有单独添加过巡防组织或本级单位
        if (curList.findIndex((v: CruisePlanTeamMemberData) => v.ReferType == e.ReferType && v.ReferId == e.ReferId && v.CruiserId == 0) > -1) {
          this.$message({
            message: e.CruiserName + '隶属于' + referName + ', 不需要重复添加',
            type: 'warning'
          })
          skip = true
        }
      }
      else {
        //先添加了人员，在添加机构/组织。判断该机构是否添加过人员
        var cruiserList = curList.filter((v: CruisePlanTeamMemberData) => v.ReferType == e.ReferType && v.ReferId == e.ReferId && v.CruiserId > 0)
        if (cruiserList.length > 0) {
          skip = true
          this.$confirm('已为' + referName + '添加过具体巡查人员，是否要替换为' + referName + '下的所有人员?', '请确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              //删除已添加的人员
              cruiserList.forEach((d: CruisePlanTeamMemberData, j: number) => {
                var index = curList.findIndex((v: CruisePlanTeamMemberData) => v.ReferType == d.ReferType && v.ReferId == d.ReferId && v.CruiserId == d.CruiserId)
                curList.splice(index, 1)
              })
              //添加单独的组织记录
              if (curList.findIndex((v: CruisePlanTeamMemberData) => v.ReferType == e.ReferType && v.ReferId == e.ReferId && v.CruiserId == 0) < 0) {
                curList.push(newItem)
              }
            })
            .catch(() => {
              // this.$message({
              //   type: 'info',
              //   message: '已取消操作'
              // });
            })
        }
      }
      if (!skip) {
        if (curList.findIndex((v: CruisePlanTeamMemberData) => v.ReferType == e.ReferType && v.ReferId == e.ReferId && v.CruiserId == e.CruiserId) < 0) {
          curList.push(newItem)
        }
      }
    })
  }
  public delTeamMember(index: number) {
    this.$confirm('确定要删除吗?', '请确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.form.TeamMembers.splice(index, 1)
      })
      .catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消操作'
        // });
      })
  }
  public closeUserSearch() {
    console.log('这里是查询巡查人员组件关闭后回传的事件')
  }
  //#endregion
  //#region 巡查对象/文保单位
  public showUnitModal(data: any) {
    window.eventBus.$emit('openCruisePlanSelectUnit', data)
  }
  public openUnit() {
    this.unitIndex = -1
    //打开文保单位 多选控件
    window.eventBus.$emit('openCruisePlanSelectUnits')
    //文保单位选择控件(单选)，新增时改用多选，修改用单选
    //this.showUnitModal(null)
  }
  public unitIndex: number = -1
  public addUnits(data: CruisePlanUnitData[]) {
    data.forEach((v: any) => {
      this.addUnit(v)
    })
  }
  public addUnit(data: CruisePlanUnitData) {
    var f = this.form
    if (this.unitIndex > -1) {
      // f.UnitList[this.unitIndex] = data
      this.$set(f.UnitList, this.unitIndex, data)
    }
    else {
      if (f.UnitList.findIndex((v: CruisePlanUnitData) => v.LevelId == data.LevelId && v.CityId == data.CityId && v.CountyId == data.CountyId && v.UnitId == 0) < 0) {
        f.UnitList.push(data)
      }
    }
  }
  public editUnit(index: number) {
    this.unitIndex = index
    this.showUnitModal(this.form.UnitList[index])
  }
  public delUnit(index: number) {
    this.$confirm('确定要删除吗?', '请确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.form.UnitList.splice(index, 1)
      })
      .catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消操作'
        // });
      })
  }
  public closeUnitSearch() {
    console.log('这里是查询巡查人员组件关闭后回传的事件')
  }
  //#endregion

  public onSubmit() {
    var f = this.form
    if (f.ScheduleList.length == 0) {
      this.$message({
        message: '请添加巡查时段',
        type: 'warning'
      })
      return false
    }
    if (f.TeamMembers.length == 0) {
      this.$message({
        message: '请添加巡查人员',
        type: 'warning'
      })
      return false
    }
    if (f.UnitList.length == 0) {
      this.$message({
        message: '请添加巡查单位',
        type: 'warning'
      })
      return false
    }

    const promist = f.Id > 0 ? putData(f.Id, f) : postData(f)
    promist.then((response: { data: any }) => {
      const data = response.data
      if (data && !data.IsError) {
        this.$message({
          message: '提交成功',
          type: 'success'
        })
        this.$router.push({ path: `/CruisePlan` }).catch((data: any) => {
          console.log(this.$route.path, data)
        })
      } else {
        this.$message({
          dangerouslyUseHTMLString: true, message: `${data.Message}`, type: 'warning'
        })
        console.log(response)
      }
    })
  }
  public onCancel() {
    this.$router.push({ path: '/CruisePlan' }).catch((data: any) => {
      console.log(this.$route.path, data)
    })
  }
  public fetchSource() {
    getLookupByType(enLookupType.CruiseSchedule, this.firstType).then(
      (response: { data: any }) => {
        const data = response.data
        if (data) {
          this.scheduleList = data
        }
      }
    )
  }
  public fetchPlan(id: number) {
    this.loading = true
    getInfo(id).then((response: { data: any }) => {
      let data = response.data
      if (data) {
        //复制巡查计划，需要把id清空，这样后端才会新增一个计划
        if (this.$route.path.indexOf('Copy') > -1) {
          data.Id = 0
          if (data.ScheduleList) {
            data.ScheduleList.forEach((e: CruisePlanScheduleData) => {
              e.Id = e.CruisePlanId = 0
            })
          }
          if (data.TeamMembers) {
            data.TeamMembers.forEach((e: CruisePlanTeamMemberData) => {
              e.Id = e.CruisePlanId = 0
            })
          }
          if (data.UnitList) {
            data.UnitList.forEach((e: CruisePlanUnitData) => {
              e.Id = e.CruisePlanId = 0
            })
          }
        }
        this.form = data
        this.scheduleChange(false)
        const item = getDDLItem(this.scheduleList, this.form.ScheduleId)
        if (item) {
          this.scheduleTooltip = item.ExInfo.Explain
        }
        this.rules = getFormRules(this.form.Id, this.form)
        if (this.form.Id == 0) {
          this.$refs.formCtrl.clearValidate()
        }
        this.loading = false
      }
    })
  }
  public fetchData() {
    const id = +this.$router.currentRoute.params.id || 0
    this.fetchPlan(id)
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
}
